import type { ReactNode } from 'react';
import * as Dialog from '@radix-ui/react-dialog';

interface ReviewDialogProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  ariaLabel: string;
  children: ReactNode;
}

/** Shared review frame for Monitoring and transaction revenue details. */
export function ReviewDialog({ isOpen, onClose, title, ariaLabel, children }: ReviewDialogProps) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <Dialog.Content
          className="fixed left-1/2 top-1/2 z-50 flex max-h-[90vh] w-full max-w-3xl -translate-x-1/2 -translate-y-1/2 flex-col rounded-xl bg-white shadow-2xl focus:outline-none max-sm:max-w-[95vw]"
          aria-label={ariaLabel}
          aria-describedby={undefined}
        >
          <div className="flex shrink-0 items-center justify-between border-b border-[#e8e8e8] px-6 py-4">
            <Dialog.Title className="text-lg font-semibold text-[#333]">{title}</Dialog.Title>
            <Dialog.Close
              className="rounded-md p-1 text-[#999] transition-colors hover:bg-[#f0f0f0] hover:text-[#333] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#6B0F1A]"
              aria-label="Close"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              >
                <path d="M4 4l8 8M12 4l-8 8" />
              </svg>
            </Dialog.Close>
          </div>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
